import { useCallback, useRef } from "react";
import Webcam from "react-webcam";
import * as poseDetection from '@tensorflow-models/pose-detection'

const videoConstraints = {
    width: 1980,
    height: 1080,
    facingMode: "user"
};

const TestCam = ()=>{
    const webcamRef = useRef(null);
    const imgRef = useRef(null);
    const detectorCreator = async ()=>{
        await poseDetection.createDetector(poseDetection.SupportedModels.MoveNet,{modelType:poseDetection.movenet.modelType.MULTIPOSE_LIGHTNING})
        .then(detector=>{return detector})
    }
    const detector = detectorCreator()
    const capture = useCallback(
      () => {
        const imageSrc = webcamRef.current.getScreenshot();
        imgRef.current.src = imageSrc
        console.log(imgRef)
      },
      [webcamRef]
    );
    return (
      <>
        <Webcam
          audio={false}
          height={720}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          width={1280}
          videoConstraints={videoConstraints}
        />
        <button onClick={capture}>Capture photo</button>
        <a id="download-photo" href="">Download Photo</a>
        <img ref={imgRef} src=""></img>
      </>
    )

}

export default TestCam